<template>
  <div class="board-box" v-loading="loading">
    <div :id="chartId" class="chart1"></div>
  </div>
</template>

<script>
import common from './mixins/common'

/**
 * 饼形图
 */
export default {
  mixins: [common],
  name: 'ChartPie2',
  props: {
    /**
     * 放置源头
     * - zjServiceType 总监-服务请求单 某个工程类型
     * - zjUnusual 总监-服务请求单 异常
     */
    source: {
      type: String,
      default: 'zjServiceType',
    },
    requestType: { type: String, default: '' },
  },
  data() {
    return {
      chartData: {},
    }
  },
  computed: {
    conf: function () {
      let that = this
      const Map = {
        zjServiceType: {
          fieldConf: { xField: 'BRAND_NAME' },
          triggerClick: (data) => {
            var uniqueId = data.name + '全部工程服务请求单'
            let condition = {}
            condition['BRAND_NAME:2'] = data.name
            condition['WORK_ORDER_TYPE:1'] = that.requestType
            that.baseComponent.smartLoadComponent(
              'serviceRequest',
              { title: uniqueId, source: 'viewBoard', condition: condition, requestUniqueId: uniqueId },
              { uniqueName: 'todo-' + uniqueId }
            )
          },
          // fieldConf: { mock: true, xField: 'brand' }
        },
        zjUnusual: {
          fieldConf: { xField: 'BRAND_NAME' },
          triggerClick: (data) => {
            var uniqueId = data.name + '全部异常服务请求'
            let condition = {}
            condition['BRAND_NAME:2'] = data.name
            that.baseComponent.smartLoadComponent(
              'serviceRequest',
              { title: uniqueId, source: 'viewBoard', condition: condition, requestUniqueId: '异常服务请求' },
              { uniqueName: 'todo-' + uniqueId }
            )
          },
          // fieldConf: { mock: true, xField: 'brand' }
        },
      }

      return Map[this.source] || {}
    },
  },
  watch: {
    chartData: function () {
      this.updateChart()
    },
    requestType: {
      handler: function (val) {
        if (val && this.source === 'zjServiceType') {
          this.getData()
        }
      },
    },
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    updateChart: function () {
      let chartData = this.chartData,
        optConf = this.conf
      let options = {
        title: {
          text: ['{name|总数 } \n', `{value|${chartData.total}}{unit|个 }`].join(''),
          top: 'center',
          left: '40%',
          textAlign: 'center',
          textStyle: {
            rich: {
              name: { color: '#4B535E', fontSize: 14 },
              value: {
                color: '#2C3542',
                fontSize: '21',
                fontWeight: 'bold',
                lineHeight: '28',
              },
              unit: { color: '#4B535E', fontSize: 12 },
            },
          },
        },
        legend: {
          show: true,
          type: 'scroll',
          orient: 'vertical',
          right: 30,
          top: 20,
          bottom: 20,
          data: chartData.legend,
          // selected: chartData.selected
        },
        series: [
          {
            name: '品牌',
            type: 'pie',
            center: ['40%', 'center'],
            radius: ['50', '90'],
            avoidLabelOverlap: true,
            label: { show: true, position: 'outer', alignTo: 'none', bleedMargin: 5 },
            labelLine: {
              show: true,
            },
            data: chartData.series,
          },
        ],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
      }

      this.chartIns && this.chartIns.setOption(options)
    },

    /**
     * 处理数据
     * @param {[]} list
     */
    processList: function (list) {
      let { xField } = this.conf.fieldConf

      let /** 类别 */ legend = [],
        /** 类别对应数量 */ series = [],
        total = 0

      let categoryMap = {}

      list.map((v) => {
        let curX = v[xField]

        if (!categoryMap[curX]) categoryMap[curX] = []
        categoryMap[curX].push(v)
      })

      legend = Object.keys(categoryMap)
      series = legend.map((curX) => {
        let n = (categoryMap[curX] || []).reduce((total, cur) => (total += 1), 0)

        total += n
        return { name: [curX].join(','), value: n }
      })

      this.chartData = { legend, series, total }
    },
    getData: function () {
      let condition = this.condition,
        requestType = this.requestType,
        /** @type {import('../index.vue').IRoleId} */
        roleId = this.roleId,
        { mock } = this.conf.fieldConf,
        source = this.source

      this.loading = true
      let requestFn = ''
      if (source === 'zjServiceType') {
        condition['WORK_ORDER_TYPE:0'] = requestType
        requestType &&
          (requestFn = this.api.queryList(
            'YW_WORK_ORDER_DETAIL_V1',
            { p2: condition, p9: '' },
            `${roleId}_chart_zjServiceType`
          ))
      } else if (source === 'zjUnusual') {
        requestFn = this.api.queryList(
          'YW_SERVICE_ORDER_YICHANG_V1',
          { p2: condition, p9: '' },
          `${roleId}_chart_zjUnusual`
        )
      }
      requestFn &&
        requestFn.then(
          (res) => {
            this.loading = false
            let resData = (this.sourceList = res.result)

            // TODO: 模拟数据
            if (mock) {
              resData = this.genTableData(10)
            }

            this.processList(resData)
          },
          (err) => {
            this.loading = false
          }
        )
    },
  },
}
</script>

<style lang="postcss"></style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartPie2.vue